// useStarPositions.js
import { useState, useEffect } from 'react';

export const useStarPositions = () => {
  const [visibleStars, setVisibleStars] = useState([false, false, false, false, false]);
  const [starPositions, setStarPositions] = useState([]);

  // Effekt for å vise stjernene gradvis
 useEffect(() => {
    const timers = [
      setTimeout(() => setVisibleStars(prev => [true, prev[1], prev[2], prev[3], prev[4]]), 500),
      setTimeout(() => setVisibleStars(prev => [prev[0], true, prev[2], prev[3], prev[4]]), 1000),
      setTimeout(() => setVisibleStars(prev => [prev[0], prev[1], true, prev[3], prev[4]]), 1500),
      setTimeout(() => setVisibleStars(prev => [prev[0], prev[1], prev[2], true, prev[4]]), 2000),
      setTimeout(() => setVisibleStars(prev => [prev[0], prev[1], prev[2], prev[3], true]), 2500),
    ];

    return () => timers.forEach(timer => clearTimeout(timer));
  }, []);

  // Håndtering av skjermstørrelse og stjerneposisjoner
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        // Posisjoner for liten skjerm (5 stjerner)
        setStarPositions([
          { top: '10%', left: '20%' },   // Star1 for small screen
          { top: '15%', right: '10%' },  // Star2 for small screen
          { bottom: '20%', right: '30%' }, // Star3 for small screen
          { bottom: '15%', left: '40%' }, // Star4 for small screen
          { top: '50%', left: '10%' }   // Star5 for small screen
        ]);
      } else {
        // Posisjoner for stor skjerm (15 stjerner)
        setStarPositions([
          { top: '5%', left: '10%' },
          { top: '10%', right: '5%' },
          { bottom: '15%', right: '100%' },
          { bottom: '10%', right: '40%' },
          { top: '40%', left: '5%' },
          { bottom: '40%', right: '5%' },
          { top: '20%', right: '25%' },
          { bottom: '25%', left: '30%' },
          { top: '35%', left: '25%' },
          { bottom: '80%', right: '50%' },
          { top: '50%', right: '15%' },
          { bottom: '50%', left: '20%' },
          { bottom: '20%', right: '80%' },
          { bottom: '20%', left: '100%' },
          { top: '10%', right: '100%' },
        ]);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Sett initial posisjon basert på skjermstørrelse

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return { visibleStars, starPositions };
};
